/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { displayScreen } from 'redux/actions/screen_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import ValidationScreen from 'components/screens/validation/validation';



/* ========== ~~~~~~~~~~ VALIDATION SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedStatus }) => ({
});

// map actions
const mapDispatchToProps = dispatch => ({
    displayScreen: (screen) => dispatch(displayScreen(screen)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    null,
    mapDispatchToProps
)(ValidationScreen);
